/* eslint-disable consistent-return */
import { flow, makeAutoObservable } from 'mobx';
import {
  SETTINGS_FRAGMENT,
  SUPERADMIN_SETTINGS_QUERY,
  UPDATE_SETTINGS_MUTATION,
  Settings,
} from '@graphql';
import { graphqlApi, reauthChallengeErrorHandler } from '@utils';
import { toast } from 'react-toastify';
import { store } from '@store';
import { DEFAULT_HTTP_RESPONSE, handleQueryError, handleQueryResponse } from './defaults';

export class SettingsStore {
  settings: Settings = {} as Settings;

  fetchSettingsResponse: HttpResponse = DEFAULT_HTTP_RESPONSE;

  settingsResponse: HttpResponse = DEFAULT_HTTP_RESPONSE;

  constructor() {
    makeAutoObservable(this);
  }

  fetchSettings = flow(function* fetchSettings(this: SettingsStore): any {
    try {
      this.fetchSettingsResponse.status = 'pending';
      const response = yield graphqlApi(SUPERADMIN_SETTINGS_QUERY(SETTINGS_FRAGMENT));
      this.settings = handleQueryResponse<Settings>(response, 'superAdminSettings') ?? ({} as Settings);
      this.fetchSettingsResponse.status = 'ok';
      return this.settings;
    } catch (err) {
      handleQueryError(err, this.fetchSettingsResponse);
    }
  }).bind(this);

  updateSettings = flow(function* updateSettings(this: SettingsStore, variables: Settings): any {
    try {
      this.settingsResponse.status = 'pending';
      const userResponse = yield graphqlApi(UPDATE_SETTINGS_MUTATION, { input: variables });
      this.settingsResponse.status = 'ok';
      const reauthChallengeError = reauthChallengeErrorHandler(userResponse);
      if (reauthChallengeError) {
        return store.reauthChallengeStore.handleReauthStepUpRequired(userResponse);
      }
      if (userResponse?.data?.errors?.[0]?.message === 'Unauthorized') {
        store.userStore.clearSession();
        return null;
      }
      const userInfo = userResponse?.data?.data?.updateSettings;
      if (userInfo) toast('Settings updated.', { type: 'success' });
      else toast('Settings update failed.', { type: 'info' });
      return userInfo;
    } catch (err) {
      toast('Something went wrong', { type: 'success' });
      this.settingsResponse.status = 'badRequest';
      this.settingsResponse.errMessage = 'Bad Request';
    }
  }).bind(this);
}
